const currency = (amount) =>{
    var fmt = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
    });
    
    return `₦${fmt.format(amount)}`;
  }

  export default currency;